import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { WITH_CORRELATION_ID } from "./correlation-id.context";

import { CorrelationIdService } from "@app/core/services/correlation-id.service";

@Injectable()
export class CorrelationIdInterceptor<T> implements HttpInterceptor {
  private readonly correlationId = inject(CorrelationIdService);

  intercept(req: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
    const id = this.correlationId.getCurrentId();

    if (id && req.context.get(WITH_CORRELATION_ID)) {
      return next.handle(
        req.clone({
          setHeaders: {
            "X-Correlation-ID": id,
          },
        }),
      );
    }

    return next.handle(req);
  }
}
